/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataRest, DevicesVctListData, InvitationVctData, SiteVctListData } from '../model/api/data-rest';
import { resources } from './api';
import { CreateInvitationVct, MassiveVctInvitationsPlant } from '../model/device-vct/device-vct-invitations';

@Injectable({
	providedIn: 'root'
})

export class DeviceVctService {
	constructor(
		private http: HttpClient
	) { }

	getSitesVctList():
		Observable<SiteVctListData[]> {
		return this.http.get<SiteVctListData[]>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('sites')}${resources.get('admin')}`, {});
	}

	getDevicesVctList(siteId: number):
		Observable<DevicesVctListData[]> {
		return this.http.get<DevicesVctListData[]>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('sites')}/${siteId}${resources.get('plants')}`, {});
		//return this.http.get<DevicesVctListData[]>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('sites')}/${siteId}${resources.get('devices')}${resources.get('admin')}`, {});
	}

	getVctInvitations():
		Observable<InvitationVctData> {
		return this.http.get<InvitationVctData>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('invitations')}`, {});
	}

	createVctInvitations(invitation: CreateInvitationVct, cleanup: boolean, accept: boolean): Observable<DataRest> {
		let params: HttpParams = new HttpParams();
		params = params.set('cleanup', cleanup);
		params = params.set('accept', accept);
		return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('invitations')}`, invitation,
			{ params });
	}

	removeVctInvitations(invitationId: string): Observable<DataRest> {
		return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('invitations')}/${invitationId}`);
	}

	editVctModuleName(moduleId: number, aliasName: string): Observable<DataRest> {
		return this.http.patch<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('modules')}/${moduleId}`, { AliasName: aliasName });
	}

	editVctFeatureName(featureId: number, aliasName: string): Observable<DataRest> {
		return this.http.patch<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('features')}/${featureId}`, { AliasName: aliasName });
	}

	enableVctAux(moduleId: number, auxId: number): Observable<DataRest> {
		return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('modules')}/${moduleId}${resources.get('aux')}/${auxId}`, {}, {});
	}

	editVctAux(moduleId: number, auxId: number, icon: string): Observable<DataRest> {
		return this.http.patch<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('modules')}/${moduleId}${resources.get('aux')}/${auxId}`, { Enable: true, Icon: icon });
	}

	disableVctAux(moduleId: number, auxId: number): Observable<DataRest> {
		return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('modules')}/${moduleId}${resources.get('aux')}/${auxId}`);
	}

	resetVctInvitationApp(featureId: number): Observable<DataRest> {
		return this.http.patch<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('features')}/${featureId}${resources.get('reinvite')}`, {});
	}

	abandonVctPlant(plantId: number, cleanup: boolean): Observable<DataRest> {
		let params: HttpParams = new HttpParams();
		params = params.set('cleanup', cleanup);
		return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('devices')}/${plantId}`, { params });
	}

	abandonVctModule(moduleId: number): Observable<DataRest> {
		return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('modules')}/${moduleId}`);
	}

	abandonVctFeature(featureId: number): Observable<DataRest> {
		return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('features')}/${featureId}`);
	}

	massiveVctInvitations(plantId: number, plant: MassiveVctInvitationsPlant, accept: boolean): Observable<DataRest> {
		let params: HttpParams = new HttpParams();
		params = params.set('accept', accept);
		return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('evo')}${resources.get('v1')}${resources.get('invitations')}${resources.get('plants')}/${plantId}`, plant,
			{ params });
	}

}
